export const IN_BROWSER_TOOLBAR_MIN = 64;

export function browserChromeBottom(
  innerHeight: number,
  viewportHeight: number,
  viewportOffsetTop: number,
) {
  return Math.max(0, Math.round(innerHeight - viewportHeight - viewportOffsetTop));
}

export function tabBarPlacement({
  safeAreaBottom,
  chromeBottom,
  standalone,
  mobileBrowser = false,
}: {
  safeAreaBottom: number;
  chromeBottom: number;
  standalone: boolean;
  mobileBrowser?: boolean;
}) {
  const measuredChrome = Math.max(0, chromeBottom);
  const assumedToolbar = !standalone && mobileBrowser ? IN_BROWSER_TOOLBAR_MIN : 0;
  const bottom = Math.max(measuredChrome, assumedToolbar);
  if (bottom > 8) {
    const paddingBottom = measuredChrome > 8 ? 12 : Math.max(safeAreaBottom, 12) + 8;
    return { bottom, paddingBottom };
  }
  const homeIndicator = Math.max(safeAreaBottom, standalone ? 34 : 12);
  return { bottom: 0, paddingBottom: homeIndicator + 8 };
}
